import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.promise.js";
import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import { Button, showSuccess, useUser, Paper, Row, Col, Dropdown } from 'components';
import { showApiError } from 'utils';
import { getCurrentAmount, submitCommissionReport } from 'services';
import { PARTNER_COMMISSION_STATUS } from 'enums';
import { reportContainer, reportHeader, infoRow, infoLabel, infoValue, highlightValue, amountToPay, buttonContainer, noDataMessage } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var CurrentReportTab = function CurrentReportTab() {
  var _partners$, _reportData$partner;

  var _useUser = useUser(),
      userInfo = _useUser.userInfo;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      reportData = _useState2[0],
      setReportData = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      submitting = _useState6[0],
      setSubmitting = _useState6[1];

  var partners = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.partners) || [];

  var _useState7 = useState(partners.length === 1 ? (_partners$ = partners[0]) === null || _partners$ === void 0 ? void 0 : _partners$.id : null),
      _useState8 = _slicedToArray(_useState7, 2),
      selectedPartner = _useState8[0],
      setSelectedPartner = _useState8[1];

  useEffect(function () {
    var _partners$2;

    if (!selectedPartner && partners.length === 1) setSelectedPartner((_partners$2 = partners[0]) === null || _partners$2 === void 0 ? void 0 : _partners$2.id);
  }, [partners]);
  useEffect(function () {
    if (selectedPartner) fetchCurrentAmount();
  }, [selectedPartner]);

  var fetchCurrentAmount = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$getCurrentAmou, _yield$getCurrentAmou2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoading(true);
              _context.next = 3;
              return getCurrentAmount({
                partner: selectedPartner
              });

            case 3:
              _yield$getCurrentAmou = _context.sent;
              _yield$getCurrentAmou2 = _slicedToArray(_yield$getCurrentAmou, 2);
              res = _yield$getCurrentAmou2[0];
              err = _yield$getCurrentAmou2[1];
              setLoading(false);

              if (!err) {
                _context.next = 10;
                break;
              }

              return _context.abrupt("return", showApiError(err));

            case 10:
              setReportData(res);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchCurrentAmount() {
      return _ref.apply(this, arguments);
    };
  }();

  var handleSubmitReport = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _yield$submitCommissi, _yield$submitCommissi2, err;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setSubmitting(true);
              _context2.next = 3;
              return submitCommissionReport({
                partner_id: selectedPartner,
                amount: reportData === null || reportData === void 0 ? void 0 : reportData.net_amount
              });

            case 3:
              _yield$submitCommissi = _context2.sent;
              _yield$submitCommissi2 = _slicedToArray(_yield$submitCommissi, 2);
              err = _yield$submitCommissi2[1];
              setSubmitting(false);

              if (!err) {
                _context2.next = 9;
                break;
              }

              return _context2.abrupt("return", showApiError(err));

            case 9:
              showSuccess('Отчетът е изпратен успешно!');
              fetchCurrentAmount();

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleSubmitReport() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handlePartnerChange = function handlePartnerChange(value) {
    setSelectedPartner(value);
    setReportData(null);
  };

  var commissionPercent = Number(reportData === null || reportData === void 0 ? void 0 : (_reportData$partner = reportData.partner) === null || _reportData$partner === void 0 ? void 0 : _reportData$partner.home_visit_fee_commission_percent) || 0;
  var canSubmit = reportData && (reportData === null || reportData === void 0 ? void 0 : reportData.status) !== PARTNER_COMMISSION_STATUS.submitted && (reportData === null || reportData === void 0 ? void 0 : reportData.status) !== PARTNER_COMMISSION_STATUS.accepted && Number(reportData === null || reportData === void 0 ? void 0 : reportData.total_collected_amount) > 0;

  if (loading && selectedPartner) {
    return ___EmotionJSX("div", {
      css: reportContainer
    }, ___EmotionJSX("p", null, "\u0417\u0430\u0440\u0435\u0436\u0434\u0430\u043D\u0435..."));
  }

  return ___EmotionJSX(React.Fragment, null, partners.length > 1 && ___EmotionJSX(Paper, {
    margin: "0 2em 1em 2em"
  }, ___EmotionJSX(Row, {
    horizontalGap: 16
  }, ___EmotionJSX(Col, {
    sm: 12,
    md: 4
  }, ___EmotionJSX(Dropdown, {
    small: true,
    withSearch: true,
    placeholder: "\u0418\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u043F\u0430\u0440\u0442\u043D\u044C\u043E\u0440 *",
    displayKey: "name",
    uniqueKey: "id",
    value: selectedPartner,
    options: partners,
    onChange: handlePartnerChange,
    mapValue: function mapValue(val) {
      return val === null || val === void 0 ? void 0 : val.id;
    }
  })))), !selectedPartner ? ___EmotionJSX("div", {
    css: reportContainer
  }, ___EmotionJSX("p", {
    css: noDataMessage
  }, "\u041C\u043E\u043B\u044F, \u0438\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u043F\u0430\u0440\u0442\u043D\u044C\u043E\u0440")) : !reportData ? ___EmotionJSX("div", {
    css: reportContainer
  }, ___EmotionJSX("p", {
    css: noDataMessage
  }, "\u041D\u044F\u043C\u0430 \u0442\u0430\u043A\u0441\u0438 \u0414\u041F \u0437\u0430 \u043E\u0442\u0447\u0435\u0442")) : ___EmotionJSX("div", {
    css: reportContainer
  }, ___EmotionJSX("h3", {
    css: reportHeader
  }, "\u041E\u0442\u0447\u0435\u0442"), ___EmotionJSX("div", {
    css: infoRow
  }, ___EmotionJSX("span", {
    css: infoLabel
  }, "\u041D\u0430\u0442\u0440\u0443\u043F\u0430\u043D\u0430 \u0441\u0443\u043C\u0430 \u043E\u0442 \u0442\u0430\u043A\u0441\u0438 \u0414\u041F:"), ___EmotionJSX("span", {
    css: highlightValue
  }, (Number(reportData === null || reportData === void 0 ? void 0 : reportData.total_collected_amount) || 0).toFixed(2), " ", reportData === null || reportData === void 0 ? void 0 : reportData.currency)), ___EmotionJSX("div", {
    css: infoRow
  }, ___EmotionJSX("span", {
    css: infoLabel
  }, "\u041A\u043E\u043C\u0438\u0441\u0438\u043E\u043D\u0430 (", commissionPercent, "%):"), ___EmotionJSX("span", {
    css: infoValue
  }, (Number(reportData === null || reportData === void 0 ? void 0 : reportData.commission_amount) || 0).toFixed(2), " ", reportData === null || reportData === void 0 ? void 0 : reportData.currency)), ___EmotionJSX("div", {
    css: infoRow
  }, ___EmotionJSX("span", {
    css: infoLabel
  }, "\u0421\u0443\u043C\u0430 \u0437\u0430 \u0438\u0437\u043F\u043B\u0430\u0449\u0430\u043D\u0435 \u043D\u0430 \u043A\u0440\u0435\u0434\u0438\u0442\u043E\u0440 (", 100 - commissionPercent, "%):"), ___EmotionJSX("span", {
    css: amountToPay
  }, (Number(reportData === null || reportData === void 0 ? void 0 : reportData.net_amount) || 0).toFixed(2), " ", reportData === null || reportData === void 0 ? void 0 : reportData.currency)), canSubmit && ___EmotionJSX("div", {
    css: buttonContainer
  }, ___EmotionJSX(Button, {
    type: "primary",
    onClick: handleSubmitReport,
    disabled: submitting
  }, submitting ? 'Изпращане...' : 'Отчети и изплати'))));
};

export default CurrentReportTab;